export const LOGIN_REQUEST = (id, pw) => ({
    type: LOGIN_REQUEST,
});

export const LOGIN_SUCCESS = () => ({
    type: LOGIN_SUCCESS,
    payload: {
        token: localStorage.getItem("accessToken"),
    },
});

export const LOGIN_FAILURE = () => ({
    type: LOGIN_FAILURE,
});
